import { render, staticRenderFns } from "./studies-home.vue?vue&type=template&id=57c2438c&scoped=true&"
import script from "./studies-home.vue?vue&type=script&lang=ts&"
export * from "./studies-home.vue?vue&type=script&lang=ts&"
import style0 from "./studies-home.vue?vue&type=style&index=0&id=57c2438c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2438c",
  null
  
)

export default component.exports